module.exports = __webpack_public_path__ + "img/icon1.c00c901c.png";